import { TranslatePipe } from '../translate-pipe.pipe';
import { appConstants } from '../../app/app.constant';
import * as i0 from "@angular/core";
import * as i1 from "../translate-pipe.pipe";
var CommonMethodUtilityService = /** @class */ (function () {
    function CommonMethodUtilityService(translatePipe) {
        this.translatePipe = translatePipe;
    }
    CommonMethodUtilityService.prototype.getLangCtryCombi = function (lang, ctry) {
        return lang + "-" + ctry;
    };
    CommonMethodUtilityService.prototype.errorBlockForServiceResponse = function (errorCode) {
        var errorMsg;
        if (errorCode === appConstants.ERROR_204) {
            errorMsg = this.translatePipe.transform('NO_CONTENT_204_MSG');
        }
        if (errorCode === appConstants.ERROR_400) {
            errorMsg = this.translatePipe.transform('NO_CONTENT_400_MSG');
        }
        if (errorCode === appConstants.ERROR_404) {
            errorMsg = this.translatePipe.transform('NO_CONTENT_404_MSG');
        }
        if (errorCode === appConstants.ERROR_500) {
            errorMsg = this.translatePipe.transform('NO_CONTENT_500_MSG');
        }
        return errorMsg;
    };
    //POA - DONT WANT TO PROVIDE
    CommonMethodUtilityService.prototype.jsonObjForPOAReasonCode = function (commentsInput, isPOAEnabled, custName, reasonCode, fileName) {
        var jsonObj = {};
        var codeKey = 'rc_code';
        var codeValue = reasonCode;
        var commentKey = 'Comments';
        var commentValue = commentsInput;
        var poaContentOptionKey = 'Is POA Content Disabled';
        var poaContentOptionValue = isPOAEnabled;
        var custNameKey = 'Customer Name';
        var custNameValue = custName;
        var detailsKey = 'details';
        var detailsValue = {};
        detailsValue[commentKey] = commentValue;
        detailsValue[poaContentOptionKey] = poaContentOptionValue;
        detailsValue[custNameKey] = custNameValue;
        detailsValue['Files'] = fileName;
        jsonObj[codeKey] = codeValue;
        jsonObj[detailsKey] = detailsValue;
        return jsonObj;
    };
    //POA - DONT WANT TO PROVIDE
    CommonMethodUtilityService.prototype.jsonObjForCmntOnlyReasonCode = function (commentsInput, custName, reasonCode, fileName) {
        var jsonObj = {};
        var codeKey = 'rc_code';
        var codeValue = reasonCode;
        var commentKey = 'Comments';
        var commentValue = commentsInput;
        var custNameKey = 'Customer Name';
        var custNameValue = custName;
        var detailsKey = 'details';
        var detailsValue = {};
        detailsValue[commentKey] = commentValue;
        detailsValue[custNameKey] = custNameValue;
        detailsValue['Files'] = fileName;
        jsonObj[codeKey] = codeValue;
        jsonObj[detailsKey] = detailsValue;
        return jsonObj;
    };
    // File Handling
    CommonMethodUtilityService.prototype.validateFileSize = function (file) {
        var size = file.size / 1024 / 1024;
        if (size > 5.0) {
            return false;
        }
        else {
            return true;
        }
    };
    CommonMethodUtilityService.prototype.validateFileType = function (file) {
        var isFileTypeValid;
        var validFileTypes = [
            'image/gif',
            'image/png',
            'image/jpeg',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            // 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
            'application/vnd.ms-excel',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'application/msword',
            // 'application/vnd.ms-powerpoint',
            'application/pdf',
        ];
        var type = file.type;
        for (var i = 0; i < validFileTypes.length; i++) {
            if (type === validFileTypes[i]) {
                isFileTypeValid = true;
                break;
            }
            else {
                isFileTypeValid = false;
            }
        }
        return isFileTypeValid;
    };
    CommonMethodUtilityService.ngInjectableDef = i0.defineInjectable({ factory: function CommonMethodUtilityService_Factory() { return new CommonMethodUtilityService(i0.inject(i1.TranslatePipe)); }, token: CommonMethodUtilityService, providedIn: "root" });
    return CommonMethodUtilityService;
}());
export { CommonMethodUtilityService };
